"use client"

import { Sidebar } from "@/components/sidebar"
import { AdminHeader } from "@/components/admin-header"
import { useAdminAuth } from "@/hooks/use-admin-auth"

export function AdminShell({ children }: { children: React.ReactNode }) {
  const { ready } = useAdminAuth()

  if (!ready) {
    return (
      <div className="flex min-h-svh items-center justify-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    )
  }

  return (
    <div className="flex min-h-svh">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <AdminHeader />
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  )
}
